import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const RED = '#cc0000';
const EXPO = [0.22, 1, 0.36, 1];

const CertificationImage = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });

  const corners = [
    { top: '-8px', left: '-8px', borderTop: `2px solid ${RED}`, borderLeft: `2px solid ${RED}` },
    { top: '-8px', right: '-8px', borderTop: `2px solid ${RED}`, borderRight: `2px solid ${RED}` },
    { bottom: '-8px', left: '-8px', borderBottom: `2px solid ${RED}`, borderLeft: `2px solid ${RED}` },
    { bottom: '-8px', right: '-8px', borderBottom: `2px solid ${RED}`, borderRight: `2px solid ${RED}` },
  ];

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: EXPO }}
      style={{ position: 'relative', width: '100%', maxWidth: '720px', margin: '0 auto' }}
    >
      {corners.map((s, i) => (
        <div key={i} style={{ position: 'absolute', width: '18px', height: '18px', zIndex: 3, ...s }} />
      ))}
      <div style={{
        position: 'relative',
        zIndex: 1,
        background: '#ffffff',
        borderRadius: '4px',
        padding: '12px',
        border: '1px solid #ececec',
        boxShadow: '0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
      }}>
        <img
          src="/Images/QualityCertification.png"
          alt="ISO 9001:2015 Quality Management Certificate"
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: '2px',
          }}
        />
      </div>
    </motion.div>
  );
};

const QualityCertificationScreen = () => {
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: '-60px' });

  return (
    <section
      ref={sectionRef}
      style={{
        minHeight: '100vh',
        padding: '52px 60px 56px',
        textAlign: 'center',
        background: 'linear-gradient(180deg, #f4f4f4 0%, #faf8f8 50%, #ffffff 100%)',
        fontFamily: "'Inter', sans-serif",
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{
        position: 'absolute',
        top: '-80px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '600px',
        height: '200px',
        background: 'radial-gradient(ellipse, rgba(204,0,0,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, ease: EXPO }}
        style={{ position: 'relative', zIndex: 1, maxWidth: '820px', margin: '0 auto' }}
      >
        <p style={{
          margin: '0 0 12px',
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '1.8px',
          textTransform: 'uppercase',
          color: RED,
        }}>
          Quality Assurance
        </p>

        <h1 style={{
          fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
          fontWeight: 700,
          color: '#111',
          letterSpacing: '-0.5px',
          lineHeight: 1.2,
          margin: '0 0 10px',
        }}>
          ISO 9001 : 2015 Certification
        </h1>

        <p style={{
          fontSize: '15px',
          color: '#666',
          margin: '0 auto 36px',
          maxWidth: '520px',
          lineHeight: 1.65,
        }}>
          Certified Quality Management System · Internationally Recognised Standard
        </p>

        <div style={{
          background: '#ffffff',
          borderRadius: '4px',
          border: '1px solid #e8e8e8',
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          padding: '32px',
          maxWidth: '780px',
          margin: '0 auto',
        }}>
          <CertificationImage />
        </div>
      </motion.div>
    </section>
  );
};

export default QualityCertificationScreen;
